import apiClient, { extractData } from "./client";

export async function getWfhRequests(params = {}) {
  const response = await apiClient.get("/wfh-requests", { params });
  return extractData(response);
}

export async function createWfhRequest(data) {
  const response = await apiClient.post("/wfh-requests", data);
  return extractData(response);
}

export async function updateWfhRequest(id, data) {
  const response = await apiClient.patch(`/wfh-requests/${id}`, data);
  return extractData(response);
}

export async function approveWfhRequest(id, notes) {
  const response = await apiClient.post(`/wfh-requests/${id}/approve`, {
    notes,
  });
  return extractData(response);
}

export async function rejectWfhRequest(id, notes) {
  const response = await apiClient.post(`/wfh-requests/${id}/reject`, {
    notes,
  });
  return extractData(response);
}

export async function cancelWfhRequest(id) {
  const response = await apiClient.post(`/wfh-requests/${id}/cancel`);
  return extractData(response);
}
